import React, { useState, useRef } from 'react'
import { Icon } from '@iconify/react'
import { Controller } from 'react-hook-form'

export default function Date({ title, control, name }) {
  const [selectedDate, setSelectedDate] = useState('')
  const dateInputRef = useRef(null)

  const handleDateChange = (event) => {
    const rawDate = event.target.value
    const formattedDate = formatDate(rawDate)
    setSelectedDate(formattedDate)
  }

  const formatDate = (dateString) => {
    if (!dateString) return ''
    const [year, month, day] = dateString.split('-')
    return `${day}/${month}/${year}`
  }

  const handleTextClick = () => {
    dateInputRef.current?.showPicker()
  }

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <div className="relative flex items-center gap-3">
          <span>{title}: </span>
          <div
            onClick={handleTextClick}
            className="cursor-pointer whitespace-nowrap rounded-lg border border-gray-300 bg-white px-2 py-1 text-gray-700 transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-accent lg-c:px-4 lg-c:py-2"
          >
            {selectedDate || 'dd/mm/yyyy'}
            <Icon
              icon="ph:calendar-blank-bold"
              className="ml-2 inline text-2xl text-gray-accent"
            />
          </div>
          <input
            ref={dateInputRef}
            type="date"
            value={value}
            onChange={(e) => {
              handleDateChange(e)
              onChange(e.target.value)
            }}
            className="absolute bottom-0 h-0 w-0 opacity-0"
          />
        </div>
      )}
    />
  )
}
